import styled from 'styled-components';

// NEED REFACTOR

const SearchParameterStyles = styled.div`
  display: flex;
  flex: 1;
  flex-direction: ${({ inline }) => (inline ? 'row' : 'column')};
  align-items: ${(props) => (props.inline ? 'center' : 'baseline')};
  margin-bottom: ${(props) => (props.offsetBottom ? `${props.offsetBottom}px` : '')};
  width: 100%;

  &.extra {
    width: 166px;
  }

  .caption {
    font-size: 12px;
    margin-bottom: ${({ captionNoOffset }) => (captionNoOffset ? '' : '7px')};
    color: ${({ theme }) => theme.colors.limedSpruce};

    &.bold {
      margin-top: -3px;
      font-size: 16px;
      font-weight: bold;
    }

    &.strong {
      font-weight: bold;
    }

    &.required {
      position: relative;

      &:after {
        content: '*';
        color: ${({ theme }) => theme.colors.color_red};
        font-size: 14px;
        position: absolute;
        right: -10px;
      }
    }
  }
  .search-field {
    margin-left: auto;

    &.select {
      .Select {
        width: ${({ extra }) => (extra ? '85px' : '140px')};
      }
    }

    &.double {
      width: 100%;

      input {
        font-size: 12px;
      }

      & > div > div {
        width: 100%;
      }

      &.sizes {
        label {
          width: 70px;
          margin: 0;
          padding-right: 0;
          padding-left: 2px;
        }
      }

      &.volume-and-weight {
        height: 32px;
        margin-left: 0;

        label {
          width: 100px;
          margin: 0;

          @media (max-width: 1080px) {
            width: 100%;
          }
        }
      }

      & > div {
        display: flex;
      }

      div:first-child > label {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      div:nth-child(2) > label {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 1px solid ${({ theme }) => theme.colors.color_disabled};
        text-overflow: ellipsis;

        &:hover,
        &:focus-within {
          border-left-color: ${({ theme }) => theme.colors.color_darkgray};
        }
      }
    }

    &.geo-suggest {
      width: 290px;
      position: relative;

      .no-suggestions {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        background-color: ${({ theme }) => theme.colors.color_white};
        border: 1px solid ${({ theme }) => theme.colors.color_darkgray};
        border-top-color: ${({ theme }) => theme.colors.border_top_color};
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
        box-sizing: border-box;
        margin-top: -1px;
        width: 100%;
        -webkit-overflow-scrolling: touch;
        font-size: 12px;
        color: #666;
        padding: 9px;
        position: absolute;
        top: 32px;
        left: 0;
      }

      @media (min-width: 768px) {
        width: 200px;
        min-width: 200px;
      }

      @media (max-width: 1080px) {
        width: 100%;
      }

      @media (max-width: 567px) {
      }
    }

    &.brand,
    &.model {
      width: 100%;
    }

    &.date-of-announcement {
      width: 200px;
    }

    &.type-of-transport {
      width: 420px;

      .Select-input:focus {
        outline: 0;
      }

      @media (max-width: 1080px) {
        width: 100%;
      }
    }

    &.rent-price {
      display: flex;
      & > div {
        width: 100%;
      }
    }

    &.small {
      width: 70px;

      label {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    &.invalid {
      label {
        background-color: ${({ theme }) => theme.colors.color_error_bg};
        border: 1px solid ${({ theme }) => theme.colors.color_error};

        input {
          background: none;
          border: 0;
        }
      }
    }
  }
  }
`;

export default SearchParameterStyles;
